var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { hangPromise } from "@irati/utils/promise";
import { FormattedMessage } from "@irati/utils/lang";
import { Office } from "@irati-web/fields/user";
import Loading from "@irati/ui/src/Loading";
import Button, { IconButton } from "@irati/ui/src/Button";
import Form from "@irati/ui/src/Form";
import Flex from "@irati/ui/src/Flex";
import { H2 } from "@irati/ui/src/Headings";
import { Label2 } from "@irati/ui/src/Labels";
import hasMultipleOffices from "@irati/identity/utils/tenant/hasMultipleOffices";
var StyledBody = styled(Label2)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 20px;\n"], ["\n  text-align: center;\n  margin-bottom: 20px;\n"])));
var AddPeopleSelectAnOffice = /** @class */ (function (_super) {
    __extends(AddPeopleSelectAnOffice, _super);
    function AddPeopleSelectAnOffice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise()
        };
        _this.handleOfficeSelect = function (office) { return _this.setState({ office: office }); };
        _this.handleSubmit = function () { return _this.props.selectOffice(_this.state.office); };
        return _this;
    }
    AddPeopleSelectAnOffice.prototype.componentDidMount = function () {
        var _this = this;
        var load = hasMultipleOffices().then(function (has) {
            if (!has) {
                _this.props.selectOffice(undefined);
                return hangPromise();
            }
        });
        this.setState({ load: load });
    };
    AddPeopleSelectAnOffice.prototype.render = function () {
        var _a = this.state, load = _a.load, office = _a.office;
        var _b = this.props, back = _b.back, alignLeft = _b.alignLeft;
        return (React.createElement(Loading, { load: load },
            React.createElement(Flex, { alignItems: "center", margin: "0 0 30px 0" },
                React.createElement(IconButton, { onClick: back, icon: "backArrow" }),
                React.createElement(H2, { margin: alignLeft ? "0 0 0 15px" : "0 auto 15px" },
                    React.createElement(FormattedMessage, { id: "admin.components.addPeopleCSV.selectOffice.header" }))),
            React.createElement(Form, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xsOffset: 2, xs: 8 },
                        React.createElement(StyledBody, { block: true },
                            React.createElement(FormattedMessage, { id: "admin.components.addPeopleCSV.selectOffice.body1" }))),
                    React.createElement(Col, { xsOffset: 2, xs: 8 },
                        React.createElement(StyledBody, { block: true },
                            React.createElement(FormattedMessage, { id: "admin.components.addPeopleCSV.selectOffice.body2" }))),
                    React.createElement(Col, { xsOffset: 2, xs: 8 },
                        React.createElement(Office, { value: office, onChange: this.handleOfficeSelect }),
                        React.createElement(Flex, { justifyContent: "flex-end" },
                            React.createElement(Button, { primary: true, onClick: this.handleSubmit }, "Continue")))))));
    };
    return AddPeopleSelectAnOffice;
}(PureComponent));
export default AddPeopleSelectAnOffice;
var templateObject_1;
